"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidEarlyBirdDiscounts = void 0;
const getValidEarlyBirdDiscounts = (data, days_in_advance) => {
    const lowestDiscount = [];
    if (data.length === 0)
        return null;
    data.forEach((item) => {
        if (item.discount?.early_bird_discounts &&
            item.discount.early_bird_discounts.length > 0) {
            const filtered_discounts = item.discount.early_bird_discounts.filter((discount) => discount.min_days_in_advance <= days_in_advance);
            filtered_discounts.forEach((discount) => {
                lowestDiscount?.push(discount);
            });
        }
    });
    return lowestDiscount;
};
exports.getValidEarlyBirdDiscounts = getValidEarlyBirdDiscounts;
